export default __webpack_public_path__ + "static/media/chat-icon1.bc148746.svg";